import styled from '@emotion/styled'
import { GridCell } from '@mobi/component-library/Common/Grid'
import { hexColors } from '@mobi/settings/hexColors'

interface SingleDayStyledProps {
  isInThisMonth?: boolean
  isDayToday?: boolean
  isSelected?: boolean
}

export const CalendarDatePickerContainerStyled = styled.div({
  textAlign: 'center',
  margin: '0 auto',

  '&:focus': { outline: 'none' },
})

export const DaysOfTheWeekStyled = styled.span({
  fontSize: '1.2rem',
  color: hexColors.black,
  lineHeight: '4rem',
})

export const SingleDayStyled = styled.span<SingleDayStyledProps>(
  {
    display: 'flex',
    height: '4rem',
    fontSize: '1.2rem',
    justifyContent: 'center',
    alignItems: 'center',

    '&:hover': {
      backgroundColor: hexColors.grey,
      color: hexColors.white,
    },
  },

  ({ isInThisMonth }) => ({
    color: isInThisMonth ? hexColors.black : hexColors.veryLightGrey,
    backgroundColor: isInThisMonth ? hexColors.white : hexColors.whiteSmoke,
    boxShadow: isInThisMonth
      ? `0 0 0 1px ${hexColors.whiteSmoke}`
      : `0 0 0 1px ${hexColors.whiteSmoke}`,
  }),

  ({ isDayToday, isSelected }) => ({
    backgroundColor: isDayToday && isSelected ? hexColors.chocolate : undefined,
    color: isDayToday && isSelected ? hexColors.white : hexColors.black,
    fontWeight: isDayToday && isSelected ? 800 : 0,
  }),

  ({ isSelected }) => ({
    backgroundColor: isSelected ? hexColors.chocolate : undefined,
    color: isSelected ? hexColors.white : undefined,
  }),

  ({ isDayToday, isSelected }) => ({
    fontWeight: isDayToday && !isSelected ? 800 : 0,
  })
)

export const MatrixStyled = styled(GridCell)({
  backgroundColor: hexColors.whiteSmoke,
})

export const SelectStyled = styled.select({
  display: 'inline-block',
  fontSize: '1.4rem',
  padding: '0.5rem 2rem 0.5rem 0.5rem',
  margin: '0.5rem 0.1rem',
  border: `0px solid ${hexColors.black}`,
  borderRadius: '0',
  backgroundColor: hexColors.white,
  backgroundImage: `url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iMjU2cHgiIGhlaWdodD0iMjU2cHgiIHZpZXdCb3g9IjAgMCAyNTYgMjU2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNTYgMjU2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHRpdGxlPmFycm93ZG93bjwvdGl0bGU+PGcgaWQ9ImFycm93ZG93biI+PHBhdGggZD0iTTI1Niw4MGwtMzItMzJsLTk2LDk2TDMyLDQ4TDAsODBsMTI4LDEyOEwyNTYsODB6Ii8+PC9nPjwvc3ZnPg==),
   linear-gradient(to bottom, #FFF 0%,#FFF 100%)`,
  backgroundRepeat: 'no-repeat, repeat',
  backgroundPosition: 'right 0.7rem top 50%, 0 0',
  backgroundSize: '0.85rem auto, 100%',
  appearance: 'none',
})

export const YearStyled = styled.div({
  display: 'inline-block',
  fontSize: '1.4rem',
  padding: '0.5rem 2rem 0.5rem 0.5rem',
  margin: '0.5rem 0.1rem',
})

export const CalendarDatePickerHolderStyled = styled.div({
  backgroundColor: hexColors.gainsboro,
  position: 'absolute',
  left: '0',
  right: '0',
  maxWidth: '42rem',
  margin: '0 auto',
  zIndex: 2,

  animationName: 'fadeIn',
  animationDuration: '0.2s',
  animationTimingFunction: 'ease-in-out',
  visibility: 'visible',
  boxShadow: `0 1.2rem 2.1rem rgba(0,0,0,0.2)`,
})
